import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import type { RangeKey } from '@dataTypes/dashboard.types'
import type { DashboardMetricItemData } from '../../../types/dashboardMetrics.types'
import type { PatientsAgeDetailRow } from '../../../pages/Dashboard/PatientsAgeDetail/patientsAgeDetail.mockData'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PATIENT')
const BASE = `${BUSINESS_LAYER_API}/api/v1/patient/operations/patients-age`

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export type PatientsAgeChartPoint = {
  label: string
  Male: number
  Female: number
}

export type PatientsAgeAxisConfig = {
  yAxisDomain: [number, number]
  yAxisTicks: number[]
}

export type PatientsAgeOverview = {
  metrics: DashboardMetricItemData[]
  chartData: PatientsAgeChartPoint[]
  axis: PatientsAgeAxisConfig
}

function buildParams(range: RangeKey, date?: string): Record<string, string> {
  const params: Record<string, string> = { range }
  if (date) params.date = date
  return params
}

export const getPatientsAgeOverview = (
  range: RangeKey,
  date?: string,
): Promise<PatientsAgeOverview> =>
  axios
    .get<ApiResponse<{ overview: PatientsAgeOverview }>>(`${BASE}/overview`, {
      params: buildParams(range, date),
    })
    .then((response) => response.data.data.overview)

export const getPatientsAgePatients = (
  range: RangeKey,
  date?: string,
): Promise<PatientsAgeDetailRow[]> =>
  axios
    .get<ApiResponse<{ patients: PatientsAgeDetailRow[] }>>(
      `${BASE}/patients`,
      {
        params: buildParams(range, date),
      },
    )
    .then((response) => response.data.data.patients)
